import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import * as T from "utils/types";
import * as API from "app/protected_api";

const initialState: T.SDGPanelState = {
    SDGvec: new Array(17).fill(false),
    status: 'idle',
    errorMsg: null,
}

const rSDGvec = createAsyncThunk(
    'SDGPanel/rSDGvec', 
    async ()=>{
        return await API.getSDGvec()
    }
)

const uSDGvec = createAsyncThunk(
    'SDGPanel/uSDGvec', 
    async (data:{index:number, status:boolean})=>{
        return await API.patchSDGvec(data.index+1, data.status)
    }
)

export const SDGPanelThunks={rSDGvec, uSDGvec}

const SDGPanelSlice = createSlice({
    name: 'SDGPanel',
    initialState,
    reducers: {
    },
    extraReducers: builder=>{
        builder.addCase(rSDGvec.pending, (state, action) => {
            state.status = 'loading';
        });
        builder.addCase(rSDGvec.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.SDGvec = action.payload.SDGvec;
        });
        builder.addCase(rSDGvec.rejected, (state, action) => {
            state.status = 'failed';
            state.errorMsg = action.error.message;
        });
        builder.addCase(uSDGvec.fulfilled, (state, action) => {
            state.SDGvec = action.payload.SDGvec;
        });
    }
});

export default SDGPanelSlice;